import type { ErrorLike } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

import { SPAN_UPDATE_EV_INTEREST } from '@constants/otel';
import { EnergyBasketFragment } from '@generated/gql/graphql';
import { useSnackbarError } from '@hooks/useSnackbarErrors';
import { useBasketContext } from '@providers/basket/BasketProvider/Context';
import { useTrace } from '@services/otel';
import { updateEnergyRequirements } from '@utils/queries/energyQueries';

const useEvInterestUpdate = () => {
  const { withTrace } = useTrace();
  const { basketId } = useBasketContext();
  const [setEVInterest, { loading, error, reset }] = useMutation(
    updateEnergyRequirements
  );
  const setSnackbarError = useSnackbarError(reset);

  const executeEvInterestUpdate = async (
    checked: boolean,
    energy: EnergyBasketFragment
  ) => {
    try {
      const result = await setEVInterest({
        variables: {
          details: {
            basketId: basketId || '',
            electricVehicleTariffExpressionOfInterest: checked,
            paymentOption: energy.details.paymentOption,
          },
        },
      });

      return result;
    } catch (error) {
      setSnackbarError(error as ErrorLike);
      return;
    }
  };

  const submitEvInterest = (checked: boolean, energy: EnergyBasketFragment) =>
    withTrace(
      SPAN_UPDATE_EV_INTEREST,
      () => executeEvInterestUpdate(checked, energy),
      { evInterest: checked }
    );

  return {
    submitEvInterest,
    loading,
    error,
  };
};

export { useEvInterestUpdate };
